import { canUseLocalStorage, getWindow } from '@ps/web-core-utils';

interface FilterStorage {
  filterSatellites: boolean;
  games: string[];
  seats: string[];
  speeds: string[];
  state: string[];
  structures: string[];
  total: { minimum: number; maximum: number } | undefined;
}

interface TournamentStorage {
  similarFavorites?: string[];
  specificFavorites?: string[];
  dontShowRemoveDialog?: boolean;
  favorites_is_enabled?: boolean;
  filters?: FilterStorage;
  favorites_filters?: FilterStorage;
}

export const getTournamentStorage = (): TournamentStorage => {
  const rawStorage = getWindow()?.localStorage?.getItem('tournaments') ?? '{}';
  try {
    return JSON.parse(rawStorage);
  } catch {
    return {};
  }
};

export const updateTournamentStorage = (updates: Partial<TournamentStorage>): void => {
  if (!canUseLocalStorage) return;

  const currentStorage = getTournamentStorage();
  const updatedStorage = {
    ...currentStorage,
    ...updates
  };

  getWindow()?.localStorage?.setItem('tournaments', JSON.stringify(updatedStorage));
};

export const updateFavorites = (similar: string[], specific: string[]): void => {
  updateTournamentStorage({
    similarFavorites: similar,
    specificFavorites: specific
  });
};

export const tournamentStorage = {
  getTournamentStorage,
  updateTournamentStorage,
  updateFavorites
};

// For backwards compatibility, export types
export type { FilterStorage, TournamentStorage };
